module.exports = __webpack_public_path__ + "img/icon04.9e20ea9e.png";